"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var TronTransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(TronTransactionRequest, _super);
    function TronTransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TronTransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.TronTransactionRequest = TronTransactionRequest;
//# sourceMappingURL=TronTransactionRequest.js.map